export default __webpack_public_path__ + "static/media/tms-legal-logo.9c6586cf.png";